module.exports = __webpack_public_path__ + "media/components/assets/img/icons/cvc-793b7a53fd01bd7c22d5067c26cd1bed.svg";